import { memo } from 'react';
import { useTranslate } from '@tolgee/react';
import { Input, Select } from 'antd';
import { css } from '@emotion/css';
import { filter } from 'lodash-es';
import { KeywordType } from '../types';
import { useSearchContext } from '@knowledge/common/components/ItemSelectV5/Context';
export type { KeywordType } from '../types';

export const CompactKeywordSearch = memo(
  (props: {
    keywordType: KeywordType;
    setKeywordType: (keywordType: KeywordType) => void;
    setKeyword: (keyword: string) => void;
    keyWordTypes?: KeywordType[];
  }) => {
    const { t } = useTranslate();
    const keywordTypeLabelMap: Record<KeywordType, string> = {
      1: t('sider.商品名称'),
      2: t('sider.商品ID'),
      3: t('aide.主商品货号'),
      4: t('sider.SKU货号'),
      5: 'SKU ID',
    };
    const { keywordType, setKeyword, setKeywordType, keyWordTypes = [2, 3, 4] } = props;
    return (
      <Input.Group
        compact
        className={css`
          flex: 1 0 259px;
          max-width: 320px;
          display: flex !important;
        `}
      >
        <Select
          value={keywordType}
          onChange={(value) => setKeywordType(value)}
          dropdownMatchSelectWidth={false}
          options={filter(Object.entries(keywordTypeLabelMap), (e) =>
            keyWordTypes.includes(Number(e[0])),
          ).map(([value, label]) => {
            return {
              value: parseInt(value, 10),
              label,
            };
          })}
        />
        <Input.Search
          allowClear
          placeholder={t('trade.请输入')}
          onPressEnter={(e: any) => {
            setKeyword(e?.target?.value);
          }}
          onSearch={(value) => {
            setKeyword(value);
          }}
        />
      </Input.Group>
    );
  },
);

CompactKeywordSearch.displayName = 'ItemSelectV5CompactKeywordSearch';

export const KeywordSelect = memo(() => {
  const { keywordType, setParams } = useSearchContext();
  return (
    <CompactKeywordSearch
      keywordType={keywordType || 1}
      setKeywordType={(value) => {
        setParams({ keywordType: value });
      }}
      keyWordTypes={[1, 2, 3, 4, 5]}
      setKeyword={(value) => {
        setParams({ keyword: value });
      }}
    />
  );
});

KeywordSelect.displayName = 'ItemSelectV5KeywordSelect';
